import { HttpClient } from "../http";
import type { LogEntry, LogsResponse, LogStats } from "../types";

export class LogService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  async getLogs(params?: { page?: number; limit?: number; accountId?: string; status?: string; from?: string; to?: string }) {
    const qs = new URLSearchParams(
      Object.entries(params ?? {})
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => [k, String(v)])
    ).toString();
    return this.get<LogsResponse>(`/api/logs${qs ? `?${qs}` : ""}`);
  }

  async getStats() {
    return this.get<LogStats>("/api/logs/stats");
  }

  async getDailyUsage() {
    return this.get<{
      dailyLimit: number;
      usage: Array<{ date: string; replyCount: number; limitHit: boolean }>;
      totalRepliesLast30Days: number;
      daysOverLimit: number;
    }>("/api/logs/usage");
  }

  async exportLogs(params?: { accountId?: string; status?: string; from?: string; to?: string }) {
    const qs = new URLSearchParams(
      Object.entries(params ?? {})
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => [k, String(v)])
    ).toString();
    const response = await fetch(`${this.baseUrl}/api/logs/export${qs ? `?${qs}` : ""}`, {
      credentials: "include",
    });
    if (!response.ok) throw new Error("Export failed");
    return response.blob();
  }
}
